"use strict";
// @ts-ignore
try {
    self['workbox:broadcast-update:6.5.4'] && _();
}
catch (e) { }
